import { FC } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import styles from './LoginIcon.module.css';

export const LoginIcon: FC<{ onClick: () => void }> = ({ onClick }) => {
  return (
    <Icon type={IconType.account} onClick={onClick} className={styles.icon} />
  );
};
